import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/features/auth';
import type { RoleType } from '@/features/auth/types';
import { ROUTES } from '@/lib/constants/routes';

interface RoleTypeGuardProps {
  children: ReactNode;
  roleType: RoleType;
  redirectTo?: string;
}

export function RoleTypeGuard({
  children,
  roleType,
  redirectTo = ROUTES.FORBIDDEN,
}: RoleTypeGuardProps) {
  const { user } = useAuth();

  if (user?.role?.type !== roleType) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
